(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hotspots"] && !Shopify.designMode) return;
  try {
    class HotspotsManager {
    constructor(container) {
      this.container = container;
      this.hotspotTriggers = container.querySelectorAll('[data-hotspot-trigger]');
      this.productCards = container.querySelectorAll('[data-product-card]');
      this.currentActiveIndex = null;

      this.init();
    }

    init() {
      // Hide all product cards initially
      this.hideAllProducts();

      // Add click listeners to hotspot triggers
      this.hotspotTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const productIndex = parseInt(trigger.dataset.hotspotTrigger);
          this.showProduct(productIndex);
        });
      });

      // Show first available product if there are hotspots
      if (this.hotspotTriggers.length > 0) {
        const firstTrigger = this.hotspotTriggers[0];
        const firstIndex = parseInt(firstTrigger.dataset.hotspotTrigger);
        this.showProduct(firstIndex);
      }
    }

    hideAllProducts() {
      this.productCards.forEach((card) => {
        card.classList.add('hidden');
        card.classList.remove('block');
        card.style.opacity = '0';
      });
    }

    showProduct(index) {
      if (index === this.currentActiveIndex) return;

      // Hide current product card if there is one
      if (this.currentActiveIndex !== null) {
        const currentCard = this.container.querySelector(`[data-product-card="${this.currentActiveIndex}"]`);
        if (currentCard) {
          currentCard.style.opacity = '0';
          setTimeout(() => {
            currentCard.classList.add('hidden');
            currentCard.classList.remove('block');
          }, 150);
        }
      }

      // Show new product card
      const newCard = this.container.querySelector(`[data-product-card="${index}"]`);
      if (newCard) {
        const showCard = () => {
          newCard.classList.remove('hidden');
          newCard.classList.add('block');
          newCard.style.opacity = '0';

          // Force reflow
          newCard.offsetHeight;

          newCard.style.transition = 'opacity 0.3s ease-in-out';
          newCard.style.opacity = '1';
        };

        // If this is the first card being shown, show immediately
        if (this.currentActiveIndex === null) {
          showCard();
        } else {
          // Otherwise wait for fade out
          setTimeout(showCard, 150);
        }
      }

      this.currentActiveIndex = index;
      this.updateActiveStates(index);
    }

    updateActiveStates(activeIndex) {
      // Update hotspot dot states
      this.hotspotTriggers.forEach((trigger) => {
        const triggerIndex = parseInt(trigger.dataset.hotspotTrigger);
        if (triggerIndex === activeIndex) {
          trigger.classList.add('active');
        } else {
          trigger.classList.remove('active');
        }
      });
    }
  }

  // Initialize hotspots when DOM is ready
  function initializeHotspots() {
    const hotspotsContainers = document.querySelectorAll('[data-hotspots-container]');

    hotspotsContainers.forEach((container) => {
      const triggers = container.querySelectorAll('[data-hotspot-trigger]');
      const cards = container.querySelectorAll('[data-product-card]');

      if (triggers.length > 0 && cards.length > 0) {
        new HotspotsManager(container);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initializeHotspots);

  // Re-initialize for theme editor
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-hotspots-container]');
    if (container) {
      const triggers = container.querySelectorAll('[data-hotspot-trigger]');
      const cards = container.querySelectorAll('[data-product-card]');
      console.log('Section reload - triggers:', triggers.length, 'Cards:', cards.length);

      if (triggers.length > 0 && cards.length > 0) {
        new HotspotsManager(container);
      }
    }
  });

  // Also try initializing after a short delay in case blocks load asynchronously
  setTimeout(initializeHotspots, 100);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buttons"] && !Shopify.designMode) return;
  try {
    class StickyAddToBag extends HTMLElement {
    connectedCallback() {
        if (this.parentElement !== document.body) {
            this.productForm = this.closest('product-form-component');
            document.querySelectorAll('body > sticky-add-to-bag').forEach((existingBar) => existingBar.remove());
            document.body.append(this);
            return;
        }

        if (!this.productForm) return;

        this.addToCartComponent = this.productForm.querySelector('add-to-cart-component');
        this.originalButton = this.addToCartComponent?.querySelector('button[type="submit"]');
        if (!this.originalButton) return;

        this.stickyButton = this.querySelector('.sticky-add-to-bag-button');
        this.abortController = new AbortController();

        this.stickyButton.addEventListener('click', () => {
            if (!this.originalButton.disabled) this.originalButton.click();
        }, { signal: this.abortController.signal });

        document.addEventListener('variant:change', () => this.syncPricing(), { signal: this.abortController.signal });

        this.bindButtonStateSync();
        this.bindScrollVisibility();
    }

    disconnectedCallback() {
        this.abortController?.abort();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
    }

    bindButtonStateSync() {
        const stickyLabel = this.querySelector('.sticky-add-to-bag-label');

        const syncButtonState = () => {
            const originalLabel = this.originalButton.querySelector('[data-default-text]');
            this.stickyButton.disabled = this.originalButton.disabled;
            if (originalLabel) stickyLabel.textContent = originalLabel.textContent.trim();
        };

        syncButtonState();

        this.buttonObserver = new MutationObserver(syncButtonState);
        this.buttonObserver.observe(this.originalButton, { attributes: true, subtree: true, childList: true, characterData: true });
    }

    bindScrollVisibility() {
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
            this.toggleAttribute('data-visible', !entry.isIntersecting);
        });

        this.visibilityObserver.observe(this.addToCartComponent);
    }

    syncPricing() {
        const priceElement = this.productForm.querySelector('.product-price');
        if (!priceElement) return;

        // Price spans can include a "Now" label line, so take the last line as the amount
        const price = priceElement.querySelector('[ref="price"]')?.textContent.split('\n').map((line) => line.trim()).filter(Boolean).pop() || '';
        const comparePrice = priceElement.querySelector('[ref="comparePrice"]')?.textContent.trim() || '';
        const compareElement = this.querySelector('.sticky-add-to-bag-compare-price');

        this.querySelector('.sticky-add-to-bag-price').textContent = price;
        compareElement.textContent = comparePrice;
        compareElement.classList.toggle('hidden', !comparePrice);

        this.querySelector('.sticky-add-to-bag-delivery')?.classList.toggle(
            'hidden',
            (Math.round(parseFloat(price.replace(/[^0-9.]/g, '')) * 100) || 0) < Number(this.dataset.freeDeliveryThreshold)
        );
    }
}

if (!customElements.get('sticky-add-to-bag')) {
    customElements.define('sticky-add-to-bag', StickyAddToBag);
}
  } catch(e) { console.error(e); }
})();

})();
